/**
 * Exporta a XLSX el Reporte de Seguros de Asesores.
 *
 * @param {Object} params
 * @param {Array}  params.resultados - Filas del reporte (shape del backend)
 * @param {Object} params.contexto   - { ciclo, campus }
 */
import * as XLSX from 'xlsx';

const COLUMNAS = [
  '#',
  'Nombre',
  'RFC',
  'CURP',
  'Género',
  'Fecha de Nacimiento',
  'Edad',
  'Tiene Seguro',
  'Fecha de Seguro',
];

function fechaArchivo() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
}

export function exportReporteSegurosAsesoresXLS({ resultados = [], contexto = {} } = {}) {
  const {
    campus = 'Todos',
  } = contexto;

  const aoa = [
    ['REPORTE DE SEGUROS DE ASESORES'],
    [`Campus: ${campus}`],
    [`Generado: ${new Date().toLocaleString('es-MX')}`],
    [],
    COLUMNAS,
  ];

  resultados.forEach((r, idx) => {
    aoa.push([
      idx + 1,
      r.nombre || '',
      r.rfc || '',
      r.curp || '',
      r.genero || '',
      r.fecha_nacimiento || '',
      r.edad ?? '',
      r.tiene_seguro || '',
      r.tiene_seguro === 'SI' ? (r.fecha_seguro || '') : '',
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws['!cols'] = [
    { wch: 5 },
    { wch: 38 },
    { wch: 16 },
    { wch: 20 },
    { wch: 12 },
    { wch: 18 },
    { wch: 6 },
    { wch: 14 },
    { wch: 18 },
  ];
  ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: COLUMNAS.length - 1 } }];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Seguros');
  XLSX.writeFile(wb, `reporte_seguros_asesores_${fechaArchivo()}.xlsx`);
}

export default exportReporteSegurosAsesoresXLS;
